import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import { Link } from './Link';
const query = graphql`
  query AllJobOffers {
    allGreenhouseDepartment {
      departments: nodes {
        name
        id
        jobPosts {
          id
          title
          location {
            name
          }
        }
      }
    }
  }
`;
const Container = styled.div`
  text-align: left;
`;
const Grid = styled.div`
  display: grid;
  margin-bottom: 2.25rem;

  @media (min-width: ${({ theme }) => theme.smallBreakpoint}) {
    grid-template-rows: repeat(3, auto);
    grid-auto-columns: 1fr;
    grid-column-gap: 1.75rem;
    grid-auto-flow: column;
  }
`;
const JobTitle = styled.h4`
  margin-bottom: 0.5rem;
`;
export const JobBoard = () => {
  const data = useStaticQuery(query);
  const departments = data.allGreenhouseDepartment.departments;
  return (
    <Container>
      {!!departments &&
        departments.map((department) => {
          if (!department.jobPosts.length) return;
          return (
            <div key={department.id}>
              <h4>{department.name}</h4>
              <hr />
              <Grid>
                {department.jobPosts.map((jobOffer) => (
                  <div key={jobOffer.id}>
                    <JobTitle>
                      <Link to={`https://boards.greenhouse.io/rasa/jobs/${jobOffer.id}`} target="_blank">
                        {jobOffer.title}
                      </Link>
                    </JobTitle>
                    <p>{jobOffer.location.name}</p>
                  </div>
                ))}
              </Grid>
            </div>
          );
        })}
    </Container>
  );
};
